import React, {useEffect, useState} from 'react';
import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import MainLayout from "../../../commons/layout/MainLayout/index";
import ROUTERS from "../../../commons/constans/router";
import {useNavigate} from "react-router-dom";
import CheckboxComponent from "../../../commons/components/Forms/CheckboxComponent";
import API, {ROUTES} from "../../../commons/api/api";
import DialogComponent from "../../../commons/components/Modal/DialogComponent";
import {logOutRequest,resetState} from "../../Account/redux/actions";
import {useDispatch, useSelector} from "react-redux";
import {hasWhiteSpace} from "../../../utils/helpers";


const ChangePassword = () =>  {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { userInfo } = useSelector((state) => state.authReducers);

    const [showPassword,setShowPassword] = useState(false);

    const [formData,setFormData] = useState({
        password : '',
        new_password : '',
        new_password_confirmation : '',
    });

    const [dialogMessages,setDialogMessages] = useState({
        show : false,
        content : ''
    })

    const [disabledButton,setDisabledButton] = useState(true);

    const [error,setError] = useState({});


    const [dialogSuccess,setDialogSuccess] = useState(false);

    useEffect(() => {
        if(!formData.password || !formData.new_password_confirmation || !formData.new_password){
            setDisabledButton(true);
        }else{
            setDisabledButton(false);
        }

    },[formData]);

    const handleOnChangeForm = (event) => {

        const target = event.target;
        const  value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if(hasWhiteSpace(value)){
            return false;
        }

        setFormData({
            ...formData,
            [name]: value
        })
    }

    const handleSubmitForm = () => {
        setDialogMessages({
            show : true,
            content: '비밀번호를 변경하시겠습니까? '
        })
    }

    const onClickAgreePassword = () => {
        API.post(ROUTES.API_UPDATE_AUTH_ME,formData).then(res => {
            setError({});
            setDialogMessages({
                ...dialogMessages,
                show : false,
            })
            setDialogSuccess(true);

        }).catch(e => {
            let error = e.response;
            let dataError = {};
            setDialogMessages({
                ...dialogMessages,
                show : false,
            })
            switch (error.status){
                case 422 :
                    if (error.data && error.data.errors) {
                        Object.keys(error.data.errors).map(function (key, index) {
                            if(error.data.errors[key][0] === '다시 한 번 확인해 주세요.'){
                                dataError['new_password_confirmation'] = error.data.errors[key][0];
                            }else{
                                dataError[key] = error.data.errors[key][0];
                            }

                            // dataError[key] = error.data.errors[key][0];
                        });
                        setError(dataError);
                    }
                    break;
            }
        })
    }

    const onClickChangePasswordSuccess = () => {
        setDialogSuccess(false);
        dispatch(logOutRequest());
        window.logoutSNS(userInfo?.devices[0]?.login_type || 'N/A');
    }

    return (
        <MainLayout pageID={"change-password-page"} displayBottomNav={false}>
            <HeaderHs2
                title={"비밀번호 변경"}
                labelLeft={true}
                labelRight={false}
                handleLabelLeft={()=>{
                    navigate(ROUTERS.PROFILE)
                }}
            />

            <div className="wrapper">
                <div className="row">
                    <div className="col-12 mt-3">
                        <div className="input-component">
                            <label>기존 비밀번호</label>
                            <div className="input-group">
                                <input
                                    type={'text'}
                                    placeholder="기존 비밀번호를 입력해주세요."
                                    value={formData.password}
                                    name={'password'}
                                    onChange={handleOnChangeForm}
                                    className={formData.password ? 'change-password-page__password-asterisk' : ''}
                                    autoComplete={'off'}
                                    maxLength="20"
                                />
                                <span className={'change-password-page__asterisk'}>{showPassword ? formData.password : Array(formData.password.length).fill('*').join('')}</span>
                            </div>
                            <p className="change-password-page__notice-password m-0 p-0 mt-1">*영문/숫자 6자~20자 이내</p>
                            {error.password ? <span className="input-error show m-0 p-0">*{error.password}</span>  : ''}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="input-component">
                            <label>새 비밀번호</label>
                            <div className="input-group">
                                <input
                                    type={'text'}
                                    placeholder="기존 비밀번호를 입력해주세요."
                                    value={formData.new_password}
                                    name={'new_password'}
                                    onChange={handleOnChangeForm}
                                    className={formData.new_password ? 'change-password-page__password-asterisk' : ''}
                                    autoComplete={'off'}
                                    maxLength="20"
                                />
                                <span className={'change-password-page__asterisk'}>{showPassword ? formData.new_password : Array(formData.new_password.length).fill('*').join('')}</span>
                            </div>
                            <p className="change-password-page__notice-password m-0 p-0 mt-1">*영문/숫자 6자~20자 이내</p>
                            {error.new_password ? <span className="input-error show m-0 p-0">*{error.new_password}</span>  : ''}
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="input-component">
                            <label>비밀번호 확인</label>
                            <div className="input-group">
                                <input
                                    type={'text'}
                                    placeholder="기존 비밀번호를 입력해주세요."
                                    value={formData.new_password_confirmation}
                                    name={'new_password_confirmation'}
                                    onChange={handleOnChangeForm}
                                    className={formData.new_password_confirmation ? 'change-password-page__password-asterisk' : ''}
                                    autoComplete={'off'}
                                    maxLength="20"
                                />
                                <span className={'change-password-page__asterisk'}>{showPassword ? formData.new_password_confirmation : Array(formData.new_password_confirmation.length).fill('*').join('')}</span>
                            </div>
                            {error.new_password_confirmation ? <span className="input-error show m-0 p-0">*{error.new_password_confirmation}</span>  : ''}
                        </div>
                    </div>
                    <div className="col-12">

                        <CheckboxComponent
                            id={"remember_me"}
                            name={"remember_me"}
                            // value={dataLogin.remember_me}
                            handleChange={()=>{
                                setShowPassword(!showPassword)
                            }}
                            // disabled={false}
                            // title={"비밀번호 표시"}
                            subTitle={"비밀번호 표시"}
                            // image={""}
                            // imageDesc={""}
                            labelClass={`d-flex align-start change-password-page__checkbox-show-password`}
                            // checked={dataLogin.remember_me}
                        />
                    </div>
                </div>
                <div className="row change-password-page__row-button">
                    <div className="col-12">
                        <button
                            type="button"
                            className={`btn btn-block btn-primary ${disabledButton ? 'change-password-page__btn-register' : ''}`}
                            disabled={disabledButton}
                            onClick={handleSubmitForm}
                        >변경하기</button>
                    </div>
                </div>
            </div>

            {dialogMessages.show &&
                <DialogComponent
                    id={"MD3"}
                    show={dialogMessages.show}
                    title={"알림"}
                    closeBtn={"취소"}
                    customBtn={'변경'}
                    handleCustom={onClickAgreePassword}
                    handleClose={()=>{
                        setDialogMessages({
                            ...dialogMessages,
                            show: false
                        })
                    }}
                    className={'dialog-custom-button'}
                >
                    <div dangerouslySetInnerHTML={{__html : dialogMessages.content}} />
                </DialogComponent>}

            {dialogSuccess ? <DialogComponent
                id={"MD5"}
                show={dialogSuccess}
                title={"알림"}
                closeBtn={"확인"}
                handleClose={onClickChangePasswordSuccess}
            >

                비밀번호 변경이 완료되었습니다.<br />
                    모든 기기에서 해당 계정이 로그아웃 됩니다.<br />
            </DialogComponent> : ''}


        </MainLayout>
    )
}

export default ChangePassword;
